import { useAtomValue } from 'jotai';
import { useMemo } from 'react';
import { tokenAtom } from '../../lib/Session';

export const useAuthenticateApiCall = <Fetcher>(func: (token: string) => Fetcher) => {
  const token = useAtomValue(tokenAtom);

  return useMemo(
    () =>
      token
        ? func(token)
        : (((..._args: any[]): any => {
            throw new Error('Attempted to call authenticated API without a token');
          }) as unknown as Fetcher),
    [token, func]
  );
};
